import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import SectionHeader from "./SectionHeader";

const CreditsSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`) || "" : "";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <SectionHeader
        title={t("sections.credits.title")}
        description={t("sections.credits.description") || undefined}
      />
      <InputCst
        id="activity-credits"
        label={t("fields.credits") || ""}
        value={data.credits}
        onChange={(e: any) => setData({ credits: e.target.value })}
        type="number"
        min={0}
        max={1000}
        error={!!errors.credits}
        errorMessage={errMsg("credits")}
      />
    </Box>
  );
};

export default CreditsSection;
